// extracted by mini-css-extract-plugin
export default {"featured-products__title":"Categories_featured-products__title__6jXNo"};